import { FAQ_CATEGORIES, FAQ_ITEMS } from '../../help/help-constants';

export interface FaqCategory {
  id: string;
  label: string;
}

export interface FaqItem {
  id: number;
  category: string;
  question: string;
  answer: string;
}

export interface SupportState {
  activeFaqCategory: string;
  openAccordionId: number | null;
  faqCategories: FaqCategory[];
  faqItems: FaqItem[];
}

export const initialSupportState: SupportState = {
  activeFaqCategory: 'gettingStarted',
  openAccordionId: null,
  faqCategories: FAQ_CATEGORIES,
  faqItems: FAQ_ITEMS,
};
